import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/** "Other Reason" limit, same as the sales-folder Not Proceeding Reason (GJGSAM-2627). */
export const NOT_PROCEEDING_OTHER_MAX_LENGTH = 200;
export const MSG_NOT_PROCEEDING_REASON_REQUIRED = 'msg_not_proceeding_reason_required';
export const MSG_NOT_PROCEEDING_REASON_OTHER_REQUIRED = 'msg_not_proceeding_reason_other_required';
export const MSG_NOT_PROCEEDING_REASON_OTHER_MAX_LENGTH = 'msg_not_proceeding_reason_other_max_length';

/**
 * A reason is required when the job is being made not proceeding, or once one is recorded.
 * Jobs that were already not proceeding before the reason existed have none and stay saveable.
 * Mirrors JobValidator.validateNotProceedingReason on the backend.
 */
export const isJobNotProceedingReasonRequired = (
  isNotProceeding: boolean,
  wasNotProceeding: boolean,
  originalReason?: string | number | null,
): boolean => isNotProceeding && (!wasNotProceeding || (originalReason != null && originalReason !== ''));

const isBlank = (value: unknown): boolean =>
  value == null || value === '' || (typeof value === 'string' && !value.trim());

export const requiredNotProceedingReason: ValidatorFn = (control: AbstractControl): ValidationErrors | null =>
  isBlank(control.value) ? { notProceedingReason: { messageId: MSG_NOT_PROCEEDING_REASON_REQUIRED } } : null;

export const requiredNotProceedingReasonOther: ValidatorFn = (control: AbstractControl): ValidationErrors | null =>
  isBlank(control.value) ? { notProceedingReasonOther: { messageId: MSG_NOT_PROCEEDING_REASON_OTHER_REQUIRED } } : null;

/** Shows an error instead of silently cutting the text, so a pasted note over the limit is visible to the user. */
export const maxLengthNotProceedingReasonOther: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const actualLength = typeof control.value === 'string' ? control.value.length : 0;
  return actualLength > NOT_PROCEEDING_OTHER_MAX_LENGTH
    ? {
      maxlength: {
        messageId: MSG_NOT_PROCEEDING_REASON_OTHER_MAX_LENGTH,
        requiredLength: NOT_PROCEEDING_OTHER_MAX_LENGTH,
        actualLength,
      },
    }
    : null;
};
